// Top bar with brand mark, navigation, and logout.
export default function Header({ onLogout, onHistory, onPricing, currentPhase }) {
  return (
    <header className="border-b border-navy-700 bg-navy-800">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-md bg-gold text-navy-900 font-bold text-lg">
            R
          </div>
          <div>
            <div className="text-base font-semibold tracking-wide">RegDefence AI</div>
            <div className="text-xs text-slate-400">
              KYC/CDD QA &middot; Regulatory defensibility engine
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          {onHistory && currentPhase !== 'history' && <NavButton onClick={onHistory}>History</NavButton>}
          {onPricing && currentPhase !== 'pricing' && <NavButton onClick={onPricing}>Pricing</NavButton>}
          <span className="hidden text-xs text-slate-400 sm:inline">
            Powered by Cognitive Compliance
          </span>
          {onLogout && <NavButton onClick={onLogout}>Sign out</NavButton>}
        </div>
      </div>
    </header>
  );
}

function NavButton({ onClick, children }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="rounded-md border border-navy-700 px-3 py-1 text-xs text-slate-300 transition hover:border-gold hover:text-white"
    >
      {children}
    </button>
  );
}
